import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { DrawCardContentDb } from '../redux/drawCardContentDbSlice';

const useDrawCardContentDb = (cardId: string | undefined): [string | undefined, DrawCardContentDb | undefined] => {
  const drawCardContentDb = useSelector((state: RootState) => state.drawCardContentDb);
  const ids = Object.keys(drawCardContentDb.drawCardContents).filter(id => drawCardContentDb.drawCardContents[id].cardId === cardId);
  if (ids.length !== 1) return [undefined, undefined];
  const id = ids[0];
  const value = drawCardContentDb.drawCardContents[id];

  return [id, value];
}

export default useDrawCardContentDb;
